import React, { FC } from 'react';
import { numberFormat, Skeleton } from '@mofid-securities/uikit';
import Button from '@/components/Button/Button';
import { IBalanceSlideSubComponentProps } from '../../BalanceSlide.types';

interface ICardBalanceSlideAmountProps extends IBalanceSlideSubComponentProps {
  amount: number;
  onRefetch: Function;
  isCardDisabled: boolean;
}
const CardBalanceSlideAmount: FC<ICardBalanceSlideAmountProps> = ({
  isCardDisabled,
  isError,
  isLoading,
  amount,
  onRefetch,
}) => (
  <>
    {isLoading ? (
      <Skeleton className="-mb-1" height={20} width={105} />
    ) : isError ? (
      !isCardDisabled && (
        <div className="absolute bottom-0 z-10">
          <Button
            className="!h-[40px] !w-[120px] !bg-[#fff] children:!m-0 children:!p-0 max-sm:!h-8 max-sm:!w-[100px]"
            variant="default"
            onClick={() => onRefetch()}
          >
            <span className="!text-sm !text-blue-50">تلاش مجدد</span>
          </Button>
        </div>
      )
    ) : (
      numberFormat(`${amount ?? 0}`)
    )}
  </>
);

export default CardBalanceSlideAmount;
